import { useState, useEffect } from 'react';
import { BsChevronCompactLeft, BsChevronCompactRight } from 'react-icons/bs';
import { LayoutGroup, motion } from "framer-motion";
import { fadeIn, iconContainer } from "../styles/variants";
import SkillIcon from './SkillIcon';
import Btn from './Btn';
import skills from '../data/skills.json';

const Skills = ({activeComp, setActiveComp, pageHeight = 100, refs, handleClick}) => {
//carousel effect
  const [currIndex, setCurrIndex] = useState(0);
 
  const observerMargin = Math.floor(pageHeight / 2);
  
  useEffect(() => {
    // let scrollInterval = null;
    // scrollInterval = setInterval(() => {
    //   setCurrIndex((currIndex + 1)%3);
    // }, 2_000); remember to cleanup
    
    const observerConfig = {
      rootMargin: `-${
        pageHeight % 2 === 0 ? observerMargin - 1 : observerMargin
      }px 0px -${observerMargin}px 0px`,
    };
    const handleIntersection = function(entries) {
      entries.forEach((entry) => {
        if (entry.target.id !== activeComp && entry.isIntersecting) {
          setActiveComp(entry.target.id);
        }
      });
    };
    const observer = new IntersectionObserver(
      handleIntersection,
      observerConfig
    );
    observer.observe(refs['skills'].current);
    return () => observer.disconnect();
  }, [
    currIndex,
    activeComp,
    setActiveComp,
    observerMargin,
    refs,
    pageHeight
  ]);

  const prevSlide = () => {
    const isFirstSlide = currIndex === 0;
    const newIndex = isFirstSlide ? 2 : currIndex - 1;
    setCurrIndex(newIndex);
  }

  const nextSlide = () => {
    const isLastSlide = currIndex === 3;
    const newIndex = isLastSlide ? 0 : currIndex + 1;
    setCurrIndex(newIndex);
  }

//carousel slides
  const stepSlides = () => {
    if (currIndex === 0) {
      return (
        <LayoutGroup id="1">
          <div className='flex flex-col rounded-2xl duration-500 w-[100%] h-96'>
            <motion.h4 
            variants={fadeIn('left', 0.5)} 
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='text-[20px] tracking-wider font-primary font-semibold mb-12 self-start'
            >
              in my projects I always use
            </motion.h4>
            <motion.div 
              variants={iconContainer}
              initial="hidden"
              animate="visible"
              whileInView={'show'}
              viewport={{ once: false, amount: 0.3}}
              className='flex flex-wrap gap-1 md:gap-5 w-3/4 h-4/5 justify-center self-center content-center'
            >
              {skills.main.map((data, i) => {
                return <SkillIcon key={i} data={data} />
              })}
            </motion.div>
          </div>
        </LayoutGroup>
       
      )
    } else if (currIndex === 1) {
      return (
        <LayoutGroup id="2">
          <div className='flex flex-col rounded-2xl duration-500 w-[100%] h-96'>
            <motion.h4 
              variants={fadeIn('left', 0.5)} 
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: false, amount: 0.3 }} 
              className='text-[20px] tracking-wider font-primary font-semibold mb-12 self-start'
            >
              but I'm open for new things so I tried also
            </motion.h4>
            <motion.div 
            layoutId="icons"
              variants={iconContainer}
              initial="hidden"
              animate="visible"
              whileInView={'visible'}
              viewport={{ once: false, amount: 0.3 }}
              className='flex flex-wrap gap-1 md:gap-5 w-3/4 h-4/5 justify-center self-center content-center '
            >
              {skills.additional.languages.map((data, i) => {
                return <SkillIcon key={i} data={data} />
              })}
              {skills.additional.backend.map((data, i) => {
                return <SkillIcon key={i} data={data} />
              })}
              {skills.additional.ui_library.map((data, i) => {
                return <SkillIcon key={i} data={data} />
              })}
              {skills.additional.bundlers.map((data, i) => {
                return <SkillIcon key={i} data={data} />
              })}
              {skills.additional.rest.map((data, i) => {
                return <SkillIcon key={i} data={data} />
              })}
            </motion.div>
          </div>
        </LayoutGroup>
      )
    } else {
      return (
        <LayoutGroup id="3">
          <div className='flex flex-col rounded-2xl duration-500 w-[100%] h-96'>
            <motion.h4 
              variants={fadeIn('left', 0.5)} 
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: false, amount: 0.3 }} 
              className='text-[20px] tracking-wider font-primary font-semibold mb-12 self-start'
            >
              tools in my work
            </motion.h4>
            <motion.div 
            layoutId="icons"
              variants={iconContainer}
              initial="hidden"
              animate="visible"
              whileInView={'visible'}
              viewport={{ once: false, amount: 0.3 }}
              className='flex flex-wrap gap-1 md:gap-5 w-3/4 h-4/5 justify-center self-center content-center'
            >
              {skills.additional.tools.map((data, i) => {
                return <SkillIcon key={i} data={data} />
              })}
            </motion.div>
          </div>
        </LayoutGroup>
      )
    }
  }
//main container
  return (
    <section id="skills" ref={refs['skills']} className="section h-[100vh]">
      <div className="container mx-auto">
        <div className="flex flex-col gap-y-10 lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0">
          {/*text*/}
          <motion.div 
            variants={fadeIn('down', 0.2)} 
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1"
          >
            <h2 className="h2 text-accent">Skills.</h2>
           {/*skills*/}
            <div className='flex mb-12 relative group justify-center'>
              {stepSlides()}
            {/*left arrow*/}
              <button className='group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl rounded-full bg-black/20 text-white cursor-pointer'>
                <BsChevronCompactLeft onClick={prevSlide} size={30}/>
              </button>
            {/*right arrow*/}
              <button className='group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl rounded-full bg-black/20 text-white cursor-pointer'>
                <BsChevronCompactRight onClick={nextSlide} size={30}/>
              </button>
            </div>
           {/*buttons*/}
            <div className="flex gap-x-8 items-center">
              <a href="mailto:zalas.patrycja@gmail.com">
                <button className='btn btn-lg'>Contact me</button>
              </a>
              <Btn text={"My portfolio"} handleClick={handleClick} id={"work"} />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
 
  );
};

export default Skills;
